import React from 'react';
import { useMap } from 'react-leaflet';
import Control from 'react-leaflet-custom-control';
import { Box, IconButton } from '@mui/material';
import GroupIcon from '@mui/icons-material/Group';

const UsersControl = ({ position = 'bottomright' }) => {
    const map = useMap();

    const hadleClick = () => {
        map.fire('openModal', { variant: 'users' });
    }

    return (
        <Control position={position}>
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    backgroundColor: 'var(--background-paper)',
                    border: '1px solid var(--border-default)',
                    borderRadius: { xs: '6px', md: '8px' },
                    boxShadow: 'var(--shadow-md)',
                    backdropFilter: 'blur(20px)',
                    WebkitBackdropFilter: 'blur(20px)',
                    transition: 'width 0.3s ease-in-out',
                    width: { xs: '28px', md: '34px' },
                    height: { xs: '28px', md: '34px' },
                    overflow: 'hidden'
                }}
            >
                {/* Кнопка пользователей */}
                <IconButton
                    onClick={hadleClick}
                    sx={{
                        width: { xs: '28px', md: '34px' },
                        height: { xs: '28px', md: '34px' },
                        minWidth: { xs: '28px', md: '34px' },
                        borderRadius: { xs: '5px', md: '7px' },
                        color: 'var(--text-primary)',
                        '&:hover': {
                            backgroundColor: 'var(--selected-bg)',
                        }
                    }}
                >
                    <GroupIcon sx={{ fontSize: { xs: '18px', md: '20px' } }} />
                </IconButton>
            </Box>
        </Control>
    );
};

export default UsersControl; 